import React from 'react';
import {connect} from 'react-redux';
import {Button, Col, Glyphicon} from 'react-bootstrap';
import classnames from 'classnames';

const Staff = ({
  staff, open, row, onEditStaffClicked
}) => {
  const status = staff.status || '';
  const isEditable = status !== 'disabled';

  return (
    <Col lg={3} md={6}>
      <div className={classnames('panel', 'relationships-item', {open})}>
        <div className="panel-body">
          <div className="relationships-name">
            {staff.name}
          </div>
          <div className="role">
            {staff.user_group.name}
          </div>
        </div>

        <div className={classnames('panel-footer', status)}>
          <div className={'status'}>
            {status.toUpperCase()}
          </div>
          {isEditable && (
            <Button
              bsClass="float-right edit-relationships-button"
              bsStyle="primary"
              onClick={() => onEditStaffClicked(staff.links.edit, row, staff.id)}
            >
              <Glyphicon glyph="edit"/>
              EDIT
            </Button>
          )}
          <div className="clearfix"/>
        </div>
      </div>
    </Col>
  );
};

const mapStateToProps = state => ({
  staff_member_row: state.staff.staff_member_row,
  staff_member_id: state.staff.staff_member_id
});

export default connect(mapStateToProps)(Staff);



// WEBPACK FOOTER //
// ./src/components/store-details/staff.jsx